import '../index_web.css';
import SwipeableViews from 'react-swipeable-views';
import { TransactionEarningHistoryTabBar, View } from '../../../../component';
import BonusEarning from '../bonus_earning/index';
import IGamioEarning from '../igamio_earning/index';

interface Props {
  routes: any;
  activeTab: any;
  onChangeIndex: any;
  onChangeTab: any;
}

const EarningHistoryWeb = ({ routes, activeTab, onChangeIndex, onChangeTab }: Props) => {
  return (
    <>
      <View className={'earning-history-container'}>
        <TransactionEarningHistoryTabBar
          routes={routes}
          activeTab={activeTab}
          onChangeTab={onChangeTab}
        />
        <SwipeableViews
          style={{ width: '100%', display: 'flex', flexDirection: 'column', flex: 1 }}
          index={activeTab}
          onChangeIndex={onChangeIndex}>
          <View>{activeTab === 0 && <BonusEarning />}</View>
          <View>{activeTab === 1 && <IGamioEarning />}</View>
        </SwipeableViews>
      </View>
    </>
  );
};
export default EarningHistoryWeb;
